module.exports = __webpack_public_path__ + "media/images/cards/mastercard-acf1c8eef9006ad66f3878a26e20c7aa.png";